import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import uniqid from 'uniqid';
import addNotification from '../actions/addNotification';
import removeNotification from '../actions/removeNotification';

export const DEFAULT_NOTIFICATION_TIMEOUT = 3000;

const statusNotifications = {
    400: 'Bad request, check your filled fields',
    401: 'Authorization failed. Please, login again',
    418: 'Data Not In Sync',
    403: 'No permission',
    404: 'Not found',
    409: 'There are resources which depends on the object you are trying to delete.', // Only company returns this code right now
    502: 'Server bad gateway. Please, contact admins',
    503: 'Server is not ready to handle this request',
    500: 'Server error. Please, contact administrators',
};

export default function useNotification(timeout = DEFAULT_NOTIFICATION_TIMEOUT) {
    const dispatch = useDispatch();
    const createAndRemove = useCallback(
        (type, message) => {
            const notification = {
                id: uniqid(),
                message,
                type,
            };

            dispatch(addNotification(notification));

            setTimeout(() => {
                dispatch(removeNotification(notification));
            }, timeout);
        },
        [dispatch, timeout],
    );

    const handleError = useCallback(
        (message) => {
            return createAndRemove('error', message);
        },
        [createAndRemove],
    );

    const handleSuccess = useCallback(
        (message) => {
            return createAndRemove('success', message);
        },
        [createAndRemove],
    );

    const handleInfo = useCallback(
        (message) => {
            return createAndRemove('info', message);
        },
        [createAndRemove],
    );

    const handleWarning = useCallback(
        (message) => {
            return createAndRemove('info', message);
        },
        [createAndRemove],
    );

    const handleServerError = useCallback(
        (error) => {
            let errorMessage = '';

            if (error.response) {
                errorMessage = statusNotifications[error.response.status]
                    ? statusNotifications[error.response.status]
                    : error;
            } else {
                errorMessage = error.isAxiosError ? error.message : error;
            }

            return createAndRemove('error', errorMessage);
        },
        [createAndRemove],
    );

    return {
        error: handleError,
        success: handleSuccess,
        info: handleInfo,
        warning: handleWarning,
        serverError: handleServerError,
    };
}
